import default360 from '../../assets/img/default360.jpg';

export const dummyScenes = [
    {
        "uuid": "0f15973a-4166-40fe-bd69-689281815872",
        "name": "Scene 1",
        "cameraView": {
            "x": 0,
            "y": 0,
            "z": 0
        },
        scene: "https://cdn.simulanis.io/creator/uno/development/resources/5b9d1a43-8425-4cbc-bca1-feb4c1f8a404/IMAGE/45069483-228d-4804-81f5-e348ea245266.jpg",
        type: "IMAGE",
        hotspots: [],
        loop: false
    },
    {
        "uuid": "1a2b3c4d-5e6f-7890-abcd-ef1234567890",
        "name": "Scene 2",
        "cameraView": {
            "x": 0,
            "y": 0,
            "z": 0
        },
        scene: "https://cdn.simulanis.io/creator/uno/development/resources/5b9d1a43-8425-4cbc-bca1-feb4c1f8a404/IMAGE/d7caa2a5-759c-48a6-8b73-661af9af4545.jpg",
        type: "IMAGE",
        loop: false,
        hotspots: [
            {
                "uuid": "3c4d5e6f-7890-abcd-ef12-345678901234",
                "name": "Hotspot 1",
                "type": "LINK",
                "position": {
                    "x": -463.5106820912987,
                    "y": -175.2376546800731,
                    "z": 59.42681505660709
                },
                "scale": {
                    "x": 80,
                    "y": 40.2,
                    "z": 0
                },
                "inventory": {
                    "uuid": "4d5e6f78-90ab-cdef-1234-567890123456",
                    "path": "https://cdn.simulanis.io/creator/uno/development/resources/8588e015-a635-414a-8021-485a5df082ee/IMAGE/118e250e-30b0-48fa-9fe5-4ec4e971197d.png",
                    "type": "IMAGE"
                },
                timer: {
                    start: 0
                }
            }
        ]
    },
    {
        "uuid": "5e6f7890-abcd-ef12-3456-789012345678",
        "name": "Scene 3",
        "cameraView": {
            "x": 0,
            "y": 0,
            "z": 0
        },
        "inventory": {
            "uuid": "6f7890ab-cdef-1234-5678-901234567890",
            "path": "https://creator.simulanis.io/uploads/projectsinventory/16874364817658760_SB9Iu.jpg",
            "type": "IMAGE"
        },
        "loop": false,
        "hotspots": []
    },
    {
        name: "Scene 4",
        loop: false,
        cameraView: {
            "xAxis": 0.1111588256800559,
            "yAxis": -0.0003591015721775789,
            "zAxis": 0.01200874801199279
        },
        "inventory": {
            "uuid": "890abcde-f123-4567-8901-234567890123",
            "path": "https://cdn.simulanis.io/creator/uno/development/resources/96d3caa0-d258-48d2-a47b-9d0de5b1cee8/VIDEO/8bc03d92-46d9-4c49-a4f4-e0faa9bfaa8c.mp4",
            "type": "VIDEO"
        },
        "loop": false,
        "hotspots": [
            {
                "uuid": "a25e2b58-084b-4602-8782-07e7800bff48",
                "position": {
                    "x": -483.6270963259497,
                    "y": -125.8462843090988,
                    "z": -2.43042875197916
                },
                "scale": {
                    "x": 80,
                    "y": 40.2,
                    "z": 0
                },
                "inventory": {
                    "uuid": "bf0755a8-12c8-4fda-b17e-214a73ff65d1",
                    "path": "https://cdn.simulanis.io/creator/uno/development/resources/8588e015-a635-414a-8021-485a5df082ee/IMAGE/118e250e-30b0-48fa-9fe5-4ec4e971197d.png",
                    "type": "PUBLIC",
                    "fileType": "IMAGE",
                    "status": "DELETE",
                    "createdAt": "2024-01-11T09:34:43.678Z",
                    "updatedAt": "2024-02-03T09:44:55.056Z"
                },
                timer: {
                    start: 0
                }
            },
            {
                "id": 1929,
                "uuid": "628c0888-2986-47ee-85ea-d55faa281133",
                "name": "03",
                "type": "LINK",
                "position": {
                    "x": 12.59530728119858,
                    "y": -153.3438415051637,
                    "z": -474.881972676542
                },
                "scale": {
                    "x": 80,
                    "y": 40.2,
                    "z": 0
                },
                "inventory": {
                    "uuid": "bf0755a8-12c8-4fda-b17e-214a73ff65d1",
                    "path": "https://cdn.simulanis.io/creator/uno/development/resources/8588e015-a635-414a-8021-485a5df082ee/IMAGE/118e250e-30b0-48fa-9fe5-4ec4e971197d.png",
                    "type": "PUBLIC",
                    "fileType": "IMAGE",
                    "status": "DELETE",
                    "createdAt": "2024-01-11T09:34:43.678Z",
                    "updatedAt": "2024-02-03T09:44:55.056Z"
                },
                timer: {
                    start: 4
                }
            },
            {
                "id": 2377,
                "uuid": "e4ac7ef4-9fc5-48e7-89b6-c06250b76097",
                "name": "GATE NO 2",
                "type": "IMAGE",
                "position": {
                    "x": -478.5915608002364,
                    "y": 141.8584375730825,
                    "z": 8.688734040965025
                },
                "scale": {

                    "x": 35,
                    "y": 35,
                    "z": 0
                },
                "inventory": {
                    "uuid": "093c2915-5da6-4aec-bae1-50b6cfb655ac",
                    "path": "https://cdn.simulanis.io/creator/uno/development/resources/2f581657-c1e0-4f03-ae9a-ce5fcb771d48/IMAGE/62479bbb-5f3e-4ba1-8c41-59574b4eb597.png",
                    "type": "PUBLIC",
                    "fileType": "IMAGE",
                    "status": "DELETE",
                    "createdAt": "2024-01-12T10:53:26.621Z",
                    "updatedAt": "2024-02-03T09:44:55.056Z"
                },
                timer: {
                    start: 3
                }
            }
        ]
    },
    {
        name: "Scene 5",
        loop: false,
        cameraView: {
            xAxis: 0,
            yAxis: 0,
            zAxis: 0
        },
        "inventory": {
            "uuid": "a123cdef-3456-7890-1234-567890123456",
            "path": "https://video.360cities.net/360eden-com/02042953_20250309Q141402VR-1920x960.mp4",
            "type": "VIDEO"
        },
        "loop": false,
        "hotspots": []
    }
];

export const defaultScene = {
    name: "Default",
    cameraView: {
        x: 0,
        y: 0,
        z: 0
    },
    inventory: {
        path: default360,
        type: "IMAGE"
    },
    hotspots: [],
    loop: false,
    muted: true,
    description: ""
}

export const defaultNewHotspot = {
    "uuid": null,
    "name": "New Hotspot",
    "type": "IMAGE",
    "position": {
        x: -480.22342512400691,
        y: -62.41680420110185,
        z: -50.36314251938774
    },
    "scale": {
        "x": 67.2,
        "y": 67.2,
        "z": 0
    },
    "inventory": {
        "uuid": "",
        "path": "",
        "type": "IMAGE"
    },
    "timer": {
        "start": 0
    },
    "action": [
        {
            "title": "",
            "description": "",
            "inventory": {
                "uuid": "",
                "path": "",
                "type": ""
            }
        }
    ],
    "destination": ""
}